module.exports = __webpack_public_path__ + "7e367be02cd17a96d513ab74846bafb3.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff2
// module id = 381
// module chunks = 1